import React from "react";
import "./RecentReviewsCard.scss"
import { CardTitle } from "components/cardTitle";
// import { IMove, MovePaymentStatusEnum, MoveStatusEnum } from "core/model/move";
import { CardLayout } from "components/cardLayout";
// import { navigate } from "@reach/router";
import { getMoveDetailsByCustomer } from '../../core/services/moveDetailsByCustomer';
import '../../../node_modules/font-awesome/css/font-awesome.min.css'
import { ReviewItem } from "components/reviewItem";
import { Popup } from "components/Popup"
import { FormControl } from 'react-reactive-form';

const listdata = [
    { movers: '3 Movers, 1 Truck', zipCode: '75007', moveSize: 'House', estimatedSqFt: '2,400' },
    // { movers: '3 Movers, 1 Truck', zipCode: '75007', moveSize: 'House', estimatedSqFt: '2,400' },
    // { movers: '3 Movers, 1 Truck', zipCode: '75007', moveSize: 'House', estimatedSqFt: '2,400' },
    // { movers: '3 Movers, 1 Truck', zipCode: '75007', moveSize: 'House', estimatedSqFt: '2,400' },
    // { movers: '3 Movers, 1 Truck', zipCode: '75007', moveSize: 'House', estimatedSqFt: '2,400' },
    // { movers: '3 Movers, 1 Truck', zipCode: '75007', moveSize: 'House', estimatedSqFt: '2,400' },

]

export interface RecentReviewsCardProps {
    // title?: string;
    // list?: IMove[] | null;
    // paymentStatuses?: MovePaymentStatusEnum[];
    // moveStatuses?: MoveStatusEnum[];
    onClick?(item: any): void;
    cancelAmount?: boolean;
    cancelTotalAmount?: boolean;
    iconName?: any;
    title?: any;
    formControl?: FormControl;
}

export interface RecentReviewsCardState {
    rating: any,
    reviewsData: any,
    open?: boolean;
    popupContent?: string;
}

class RecentReviewsCard extends React.Component<RecentReviewsCardProps, RecentReviewsCardState> {
    constructor(props: RecentReviewsCardProps) {
        super(props);
        this.state = {
            rating: 4,
            // reviewsData:listdata
            reviewsData: [],
            open: false,
            popupContent: ""
        };
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        //var cid="6402502";
        var cid = (localStorage.getItem("CID") || "");
        let response = await getMoveDetailsByCustomer(cid);
        // debugger;
        localStorage.setItem("reviewsData", JSON.stringify(response));
        this.setState({ reviewsData: response });
        if (this.props.formControl) {
            this.props.formControl.setValue(true);
        }
        if (!this.props.formControl) {
            // debugger;
        }
    }

    handleClick(item: any) {

        // if (this.props.onClick) {
        //     this.props.onClick(item);
        // }

        //alert(item.reviewComment);

        this.setState({ popupContent: item.reviewComment });
        this.setState({ open: true });
    }

    // onExpand() {
    //     navigate('/moves', { state: { 
    //         title: this.props.title,
    //         paymentStatuses: this.props.paymentStatuses, 
    //         moveStatuses: this.props.moveStatuses 
    //     }})
    // }

    onStarClick(nextValue: any, prevValue: any, name: any) {
        debugger;
        this.setState({ rating: nextValue });
    }

    // getTotalCommissionAmount(list: IMove[]) {
    //     return list.map(item => +item.commissionAmount).reduce((a, b) => a + b, 0).toFixed(2);
    // }
    render() {
        // const { list, title } = this.props;
        return (
            <CardLayout style={{ backgroundColor: '#FBFBFB' }}
            // paginator={list ? {
            //     pageSize: list.length < PAGE_SIZE ? list.length: PAGE_SIZE,
            //     totalCount: list.length
            // } : null}
            // loading={!list}
            // onExpand={() => this.onExpand()}
            // paginatorText={"Showing 5 out of 34"}
            // iconName={"fa fa-expand"}
            // paginator={true}
            >
                <CardTitle title={this.props.title}
                    color={"rgba(0, 0, 0, 0.7)"}
                />
                {
                    this.state.reviewsData.map((item: any, index: number) => {
                        return <ReviewItem
                            key={index}
                            item={item}
                            backgroundColor={index % 2 === 0 ? ' #F3F3F3' : 'white'}
                            onClick={(item: any) => this.handleClick(item)}
                        />
                    })
                }

                <Popup open={this.state.open}
                    onClose={() => this.setState({ open: false })}
                    title={"Review Comment"}
                    content={this.state.popupContent}
                />
            </CardLayout>
        );
    }
}

export default RecentReviewsCard;